import Toast from "javascripts/common/toast";
import { micromodal, micromodalInit } from "javascripts/micromodal";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[class*=js-clip-]").forEach((element) => {
    element.classList.remove("c-clip--hide");
  });
  document.querySelectorAll(".js-clips-header-count").forEach((element) => {
    element.style.display = "flex";
  });

  document.addEventListener("ajax:success", (event) => {
    const target = event.target;
    const detail = event.detail[0];
    const cliptype = target.dataset.cliptype;
    const id = target.dataset.id;
    const method = target.dataset.method;
    const selector = `.js-clip-${cliptype}-${id}`;
    const nodes = document.querySelectorAll(selector);

    if (detail.modal_html) {
      loginModal(detail.modal_html);
      return;
    }

    if (method === "post") {
      const page_name = document.getElementById("catalyst-props").dataset.prop1.replace("_", "-");
      // eslint-disable-next-line no-undef
      onclickcatalyst_bookmark_matome(cliptype, id, page_name, target.dataset.clickarea);

      nodes.forEach((node) => {
        if (node.classList.contains("c-clip__icon")) {
          node.classList.add("c-clip__icon--cliped");
        }
        if (node.classList.contains("c-clip__button")) {
          node.classList.add("c-clip__button--cliped");
          node.textContent = "クリップ解除";
        }
        node.setAttribute("data-method", "delete");
      });
    }

    if (method === "delete") {
      nodes.forEach((node) => {
        if (node.classList.contains("c-clip__icon")) {
          node.classList.remove("c-clip__icon--cliped");
        }
        if (node.classList.contains("c-clip__button")) {
          node.classList.remove("c-clip__button--cliped");
          node.textContent = "クリップ";
        }
        node.setAttribute("data-method", "post");
        if (cliptype === "press") node.setAttribute("data-popup", "#target-clip-add");
        node.removeAttribute("data-confirm");
      });
    }

    if (detail.no_check_clip_count != null) {
      document.querySelectorAll(".js-clips-count").forEach((element) => {
        element.textContent = detail.no_check_clip_count;
      });
      document.querySelectorAll(".js-clips-signal").forEach((element) => {
        element.style.display = detail.no_check_clip_count.toString() !== "0" ? "flex" : "none";
      });
    }

    if (detail.clip_count != null) {
      nodes.forEach((node) => {
        const headerCount = node.querySelector(".js-clips-header-count");
        if (headerCount) {
          headerCount.classList.toggle("p-presses-show__clips--empty", !(detail.clip_count > 0));
          headerCount.textContent = `${detail.clip_count}`;
        }
      });
    }

    const clipAddElement = document.getElementById("target-clip-add");
    if (detail.toast) {
      clipAddElement.style.display = "none";
      clipAddElement.innerHTML = detail.toast;

      const clipPopupLinkElement = document.querySelector(".c-clip-popup__link");
      if (clipPopupLinkElement) {
        clipPopupLinkElement.addEventListener("click", () => {
          clipAddElement.style.display = "none";
        });
      }

      const clipAddToast = new Toast(clipAddElement);
      clipAddToast.show();
    } else {
      clipAddElement.style.display = "none";
    }

    if (detail.triplists) {
      const targetLists = document.getElementById("target-lists");
      targetLists.innerHTML = detail.triplists;
      targetLists.setAttribute("data-cliptype", cliptype);
      micromodalInit();
    }
  });

  document.addEventListener("ajax:error", (event) => {
    const target = event.target;
    if (target.classList.contains("js-login-form")) {
      const { error_html } = event.detail[0];
      const errorElement = document.getElementById("js-modal-error");
      errorElement.style.display = "none";
      errorElement.innerHTML = error_html;
      errorElement.style.display = "flex";
    }
  });

  const loginModal = (html) => {
    const existingModal = document.querySelector(".js-login-modal");
    if (existingModal) {
      existingModal.outerHTML = html;
    } else {
      document.body.insertAdjacentHTML("beforeend", html);
    }
    micromodal("target-new-for-ajax");
  };
});
